import { ReactNode } from 'react';
import './NoHoverTable.scss';

interface NoHoverTableProps {
  children: ReactNode;
}

function NoHoverTable({ children }: NoHoverTableProps) {
  return (
    <table className="nhsuk-table-responsive nhsuk-table--nonhover">
      {children}
    </table>
  );
}

export default NoHoverTable;
